export default __webpack_public_path__ + "media/zurb/img/party/building-9453dd55cbe7acd7051eb8f1fc53424d.png";